import { object } from 'yup';

import { createValidator } from '@src/validation';
import { textValidator } from '@src/validation/textValidator';
import { reportGroupsStore } from '@stores/dictionaryStores/reportGroupsStore/reportGroupsStore';

const validateSchema = object().shape({
  code: textValidator({ fieldName: 'code' }).test('code', 'Код должен быть уникальным', (value, { parent: { id } }) => {
    const { reportGroups } = reportGroupsStore;
    return !reportGroups.some((report) => report.code === value && report.id !== id);
  }),
  codeExt: textValidator({ fieldName: 'codeExt' }),
  name: textValidator({ fieldName: 'name' }),
  description: textValidator({ fieldName: 'description', required: false }),
});

export const validate = createValidator(validateSchema);
